<template>
    <div class="w-full">
        <TabGroup :selectedIndex="tabIndex" @change="changeTab">
            <TabList class="flex">
                <Tab as="template" v-slot="{ selected }">
                    <button class="px-2.5 py-3 focus:outline-none border-b-2"
                        :class="{ 'font-semibold text-success border-b-success': selected, 'border-b-gray-300': !selected }">
                        {{ dataLocales.data.tab1 }}
                    </button>
                </Tab>
                <Tab as="template" v-slot="{ selected }">
                    <button class="px-2.5 py-3 focus:outline-none border-b-2 "
                        :class="{ 'font-semibold  text-success border-b-success': selected, 'border-b-gray-300': !selected }">
                        {{ dataLocales.data.tab2 }}
                    </button>
                </Tab>

            </TabList>
            <TabPanels class="mt-6">
                <TabPanel>
                    <div v-html="dataLocales.data.des1"></div>
                </TabPanel>
                <TabPanel>
                    <div v-html="dataLocales.data.des2"></div>
                    <div v-html="dataLocales.data.des3"></div>
                </TabPanel>
            </TabPanels>
        </TabGroup>
        <div class="mt-6 pb-8 relative">
            <template v-if="qrcreate.imageData">
                <div
                    class="h-[52px] w-full bg-white transition-all duration-75 ease-linear text-center px-5 py-3 drop-shadow-md">
                    {{ url }}
                </div>
            </template>
            <template v-else>
                <div v-if="tabIndex == 1"
                    class="after:content-[''] after:absolute after:w-full after:h-full after:top-0 after:blur-sm after:z-0 after:bg-white flex items-center justify-center cursor-pointer absolute w-full h-[calc(100%-32px)] top-0 z-10">
                    <div class="relative z-50 flex gap-2 ">
                        <span> Login to gain access</span>
                        <LockIcon />
                    </div>
                </div>
                <input type="text" v-model="url" @click="error = false"
                    class="h-[52px] w-full bg-white transition-all duration-75 ease-linear border  px-5 py-3 focus:border-0 focus:drop-shadow-sm outline-none focus:outline-none"
                    :class="{ 'placeholder-danger border border-danger border-dashed': error, 'border-gray-300': !error }"
                    placeholder="http://">
                <p class="text-danger absolute left-0 bottom-0 text-sm" v-if="error">* {{ dataLocales.data.err_msg }}
                </p>
            </template>

        </div>
        <tools-button-create v-if="tabIndex == 0" @generate="generate" />
        <div v-else class="flex items-center justify-center gap-4 mt-8">

            <a href="https://app.qrgateway.com/sign-up" target="_blank" rel="noopener noreferrer"
                class="text-md rounded-lg h-11 px-8 bg-success shadow-light hover:bg-success-deep text-white hover:shadow-strong font-bold whitespace-nowrap transition shadow-light inline-flex items-center">
                {{ dataLocales.data.button }}
            </a>
        </div>
    </div>
</template>
  
<script lang="ts" setup>
import { TabGroup, TabList, Tab, TabPanels, TabPanel } from '@headlessui/vue';
import { LockIcon } from "vue-tabler-icons";
import DataLocale from '~~/config/interface/DataLocale';
import { useQrCreateStore } from '~~/stores/qrcreate';
const url = ref<string>('')
const tabIndex = ref(0)
function changeTab(index: number) {
    tabIndex.value = index
}
const error = ref(false)
const qrcreate = useQrCreateStore()
const qrstyle = useQrStyle()
const validateData = () => {
    const regex = /((ftp|http|https):\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/g
    if (url.value && regex.test(url.value)) {
        if (!url.value.includes('http')) {
            url.value = 'http://' + url.value
        }
        qrcreate.url.url = url.value
        return true
    }
    error.value = true;
    return false;
}
const generate = async () => {
    if (validateData()) {
        await qrstyle.GenerateQrCode({stack:true})
    }
}

const dataLocales = new DataLocale([
    {
        locale: "en",
        tab1: "URL Static Code",
        tab2: "URL Dynamic code",
        des1: "<p>The URL is directly generated into a QR code, which cannot be modified after generation, and cannot count the number of scanned codes.</p>",
        des2: " <p>Generate a QR code from a fixed short URL, and this short URL can jump to the target URL you input. </p> <p>The target URL can be modified at any time while the QR code pattern remains unchanged, and the scanning volume can be counted.</p>",
        des3:"<p>Easily redirect URLs automatically based on <b>geolocation</b> and <b>device</b>.</p>",
        button: "Register for Free",
        err_msg: "Please enter a URL in the correct format"
    },
    {
        locale: "vi",
        tab1: "Mã tĩnh cho URL",
        tab2: "Mã động cho URL",
        des1: "<p>URL được tạo trực tiếp thành mã QR, không thể sửa đổi sau khi tạo, và không thể đếm số mã đã quét được.</p>",
        des2: "<p>Tạo mã QR từ một đường dẫn ngắn cố định, và đường dẫn ngắn này có thể nhảy đến URL mục tiêu mà bạn nhập. </p><p>Đường dẫn URL mục tiêu có thể được sửa đổi bất cứ lúc nào trong khi mẫu mã mã QR vẫn không thay đổi và có thể đếm được số lượt quét.</p>",
        button: "Đăng ký miễn phí",
        err_msg: "Vui lòng nhập URL trong định dạng đúng",
        des3:"<p>Dễ dàng chuyển hướng URL tự động dựa trên <b>vị trí địa lý</b> và <b>thiết bị</b>.</p>"
    },
    {
        locale: "fr",
        tab1: "Code QR statique URL",
        tab2: "Code QR dynamique URL",
        des1: "<p>L'URL est directement générée en code QR, qui ne peut pas être modifié après la génération et ne peut pas compter le nombre de codes scannés.</p>",
        des2: "<p>Générez un code QR à partir d'une URL courte fixe et cette URL courte peut sauter vers l'URL cible que vous avez entrée.</p><p>L'URL cible peut être modifiée à tout moment alors que le modèle de code QR reste inchangé et le volume de numérisation peut être compté.</p>",
        button: "Inscrivez-vous gratuitement",
        err_msg: "Veuillez saisir une URL dans le format correct",
        des3: "<p>Rediriger facilement les URLs automatiquement en fonction de la <b>géolocalisation</b> et du <b>périphérique</b>.</p>"
    },
    {
        locale: "es",
        tab1: "Código QR estático para URL",
        tab2: "Código QR dinámico para URL",
        des1: "<p>La URL se genera directamente en un código QR, que no se puede modificar después de la generación y no puede contar el número de códigos escaneados.</p>",
        des2: "<p>Genere un código QR a partir de una URL corta fija y esta URL corta puede saltar a la URL de destino que ha ingresado.</p><p>La URL de destino se puede modificar en cualquier momento mientras el patrón del código QR permanece sin cambios y se puede contar el volumen de escaneo.</p>",
        button: "Registrarse gratis",
        err_msg: "Por favor, introduzca una URL en el formato correcto",
        des3:"<p>Redirige fácilmente las URL automáticamente según la <b>geolocalización</b> y el <b>dispositivo</b>.</p>"
    },
    {
        locale: "pt",
        tab1: "Código Estático de URL",
        tab2: "Código Dinâmico de URL",
        des1: "<p>A URL é diretamente gerada em um código QR, que não pode ser modificado após a geração e não pode contar o número de códigos digitalizados.</p>",
        des2: "<p>Gere um código QR a partir de uma URL curta fixa, e essa URL curta pode pular para a URL de destino que você inseriu.</p> <p>A URL de destino pode ser modificada a qualquer momento, enquanto o padrão do código QR permanece inalterado, e o volume de digitalização pode ser contado.</p>",
        button: "Registre-se gratuitamente",
        err_msg: "Digite uma URL no formato correto",
        des3:"<p>Facilmente redirecione URLs automaticamente com base na <b>geolocalização</b> e no <b>dispositivo</b>.</p>"
    },
    {
        locale: "nl",
        tab1: "URL-statische code",
        tab2: "URL-dynamische code",
        des1: "<p>De URL wordt rechtstreeks in een QR-code gegenereerd, die na generatie niet kan worden gewijzigd en het aantal gescande codes niet kan tellen.</p>",
        des2: "<p>Genereer een QR-code vanaf een vaste korte URL en deze korte URL kan springen naar de door u ingevoerde doel-URL.</p><p>De doel-URL kan op elk moment worden gewijzigd terwijl het QR-codepatroon ongewijzigd blijft, en het scanvolume kan worden geteld.</p>",
        button: "Registreer gratis",
        err_msg: "Voer een URL in het juiste formaat in",
        des3:"<p>Gemakkelijk URL's automatisch doorverwijzen op basis van <b>geolocatie</b> en <b>apparaat</b>.</p>"
    }
    ,
    {
        locale: "it",
        tab1: "Codice QR statico dell'URL",
        tab2: "Codice QR dinamico dell'URL",
        des1: "<p>L'URL viene generato direttamente in un codice QR, che non può essere modificato dopo la generazione e non può conteggiare il numero di codici scansionati.</p>",
        des2: "<p>Genera un codice QR da un URL breve fisso e questo URL breve può saltare all'URL di destinazione che hai inserito.</p><p>L'URL di destinazione può essere modificato in qualsiasi momento mentre il pattern del codice QR rimane invariato, e il volume di scansione può essere contato.</p>",
        button: "Registrati gratis",
        err_msg: "Inserisci un URL nel formato corretto",
        des3:"<p>Facilmente reindirizzare automaticamente gli URL in base alla <b>geolocalizzazione</b> e al <b>dispositivo</b>.</p>"
    },
    {
        locale: "ja",
        tab1: "静的URL QRコード",
        tab2: "動的URL QRコード",
        des1: "<p>URLを直接QRコードに変換します。生成後に変更できず、スキャン数をカウントできません。</p>",
        des2: "<p>固定された短縮URLからQRコードを生成し、この短縮URLは入力したターゲットURLにジャンプできます。</p><p>ターゲットURLはいつでも変更できますが、QRコードのパターンは変わらず、スキャン数をカウントできます。</p>",
        button: "無料登録",
        err_msg: "正しいURL形式で入力してください",
        des3:"<p><b>ジオロケーション</b>と<b>デバイス</b>に基づいて、簡単にURLを自動的にリダイレクトできます。</p>"
    }
    ,
    {
        locale: "zh",
        tab1: "静态URL QR代码",
        tab2: "动态URL QR代码",
        des1: "<p>将URL直接转换为QR代码，生成后无法更改，无法计算扫描次数。</p>",
        des2: "<p>从固定的短网址生成QR码，这个短网址可以跳转到您输入的目标URL。</p><p>目标URL随时可以修改，而QR码的模式保持不变，可以计算扫描量。</p>",
        button: "免费注册",
        err_msg: "请以正确的格式输入URL",
        des3:"<p>可以根据<b>地理位置</b>和<b>设备</b>轻松自动重定向URL。</p>"
    }
    ,
    {
        locale: "de",
        tab1: "URL-Static-Code",
        tab2: "URL-Dynamischer-Code",
        des1: "<p>Die URL wird direkt in einen QR-Code generiert, der nach der Erstellung nicht mehr geändert werden kann und nicht die Anzahl der gescannten Codes zählen kann.</p>",
        des2: "<p>Generieren Sie einen QR-Code aus einer festen Kurz-URL, über die Sie zur von Ihnen eingegebenen Ziel-URL gelangen können.</p><p>Die Ziel-URL kann jederzeit geändert werden, während das QR-Code-Muster unverändert bleibt, und das Scan-Volumen kann gezählt werden.</p>",
        button: "Kostenlos registrieren",
        err_msg: "Bitte geben Sie eine URL im richtigen Format ein.",
        des3: "<p>Automatisch URLs basierend auf <b>Geolocation</b> und <b>Gerät</b> leicht umleiten.</p>"
    }
])

</script>